import { createContext } from 'react';
/**
 * A LinkAdapter is a component that receives the following props:
 * * `children` - a single child of type `a` (anchor)
 * * `href` - the href that is also passed to the anchor
 * The default LinkAdapter is a React.Fragment that renders just the anchor.
 * @example
 * <LinkAdapterContext.Provider value={
 *   ({children}) => <div className="link-wrapper">{children}</div>
 * }>
 *   <Link href="/page">Go to page</Link>
 * </LinkAdapterContext.Provider>
 */

var LinkAdapterContext = createContext(function (_ref) {
  var children = _ref.children;
  return children;
});
export default LinkAdapterContext;